import React from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { gritComponentStyles } from '../gritComponentStyles';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { NonInteractiveTechnicalProfile, ValidationTP } from '../../../xmlParsing/interfaces';
import { useSelector } from 'react-redux';
import { getOtherProfiles } from '../../../store';

interface ValidationTechnicalProfileListProps {
  list: ValidationTP[];
  onEditHandler: (val: string) => void;
  onDeleteHandler: (val: string) => void;
  onOpenHandler: (val: string, vtpType: 'REST' | 'AAD' | 'OpenId') => void;
}
const getVTPType = (obj: NonInteractiveTechnicalProfile) => {
  if (obj['protocol'][0].toLowerCase().includes('openidconnect')) return 'OpenId';
  if (obj['protocol'][1].toLowerCase().includes('restful')) return 'REST';
  else return 'AAD';
};
function ValidationTechnicalProfileList({
  list,
  onOpenHandler,
  onEditHandler,
  onDeleteHandler,
}: ValidationTechnicalProfileListProps) {
  const classes = gritComponentStyles();
  const otherProfiles = useSelector(getOtherProfiles);
  return (
    <>
      {list &&
        list.map((el: ValidationTP) => {
          const vtpType = getVTPType(otherProfiles[el['id']]);
          return (
            <div key={el.id} className={cn(classes.policyEntry, classes.flexRow)}>
              <span className={classes.label}>{el.id} </span>
              <ModeEditOutlineSharpIcon
                onClick={() => onEditHandler(el['id'])}
                className={classes.icon}
                color="primary"
              />
              <OpenInNewIcon
                onClick={() => onOpenHandler(el['id'], vtpType)}
                className={classes.icon}
                color="primary"
              />
              <DeleteIcon
                onClick={() => {
                  window.confirm('Are you sure you want to delete ' + el['id'] + '? This cannot be undone.') &&
                    onDeleteHandler(el['id']);
                }}
                className={classes.icon}
                color="error"
              />
            </div>
          );
        })}
    </>
  );
}

// export default withAITracking(reactPlugin, ValidationTechnicalProfileList);
export default ValidationTechnicalProfileList;
